module.exports = __webpack_public_path__ + "static/img/tx-type.8acedb28.png";